export { default } from './InputOfDecimal';
